import React from 'react'
import Breadcrumb from '../common/Breadcrumb'

const ManagerPage = () => {
  return (
    <>
       <Breadcrumb 
            pageTitle="Manager’s Message"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Manager’s Message" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />

        <section class="space-ptb">
          <div class="container">
            <div class="row align-items-start">
              <div className='col-md-12'>
                  <h2 class="title mb-3 text-center"><span class="text-primary">Manager's Message</span></h2>
                  <div className="curved-line mx-auto mt-3"></div>
              </div>
              <div class="col-md-8">
                <div class="mb-4 pr-lg-5">         
                    <p>Pioneer Montessori School was established in 1963 with the motto “True Education with honesty”. At PMS our students leam and play in an atmosphere of care and respect.</p>
                    <p>The teachers provide a dynamic learning environment that enables children to become lifelong learners who reach their full potential and become socially well adjusted and responsible citizens.</p>
                    <p>Pioneer Montessori School is committed to providing high quality education and preparing young people to become active, engaged and responsible citizen to the country.</p>
                    <p>At Pioneer Montessori school we pride ourselves on having a friendly and supportive learning environment that has a strong focus on high quality teaching and learning, the fostering of positive relationship within the school community and on student well being.</p>
                    <p className='pt-2 fw-bold'>With best wishes</p>
                    <p className='pb-0 mb-0'>Er. Brajendra Singh</p>
                    <p>Manager</p>
                </div>            
              </div> 
              <div class="col-md-4">
                  <img src="images/team/managernew.png" className='w-100 img-redius' alt='' style={{objectFit:'cover'}} />
              </div>         
            </div>
          </div>
      </section>

       
    </>
  )
}

export default ManagerPage
